import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgSelectModule } from '@ng-select/ng-select';
import { ReactiveFormsModule } from '@angular/forms';
import { ProveedorRoutingModule } from './proveedor-routing.module';
import { SharedModule } from './shared/shared.module';

import { HomeComponent } from './home/home.component';
import { InscripcionFormComponent } from './inscripcion-form/inscripcion-form.component';
import { LayoutProveedoresComponent } from './layout-proveedores/layout-proveedores.component';

@NgModule({
  imports: [
    CommonModule,
    ProveedorRoutingModule,
    SharedModule,
    HttpClientModule,
    NgSelectModule,
    ReactiveFormsModule
  ],
  declarations: [
    HomeComponent,
    InscripcionFormComponent,
    LayoutProveedoresComponent
  ]
})
export class ProveedorModule { }
